<template>
    <div class="app flex-row align-items-center">
        <LoadingSpinner size="60px" />
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import LoadingSpinner from '../../components/LoadingSpinner';

export default {
  name: 'Init',

  components: {
    LoadingSpinner
  },

  methods: {
    ...mapActions(['refreshUser']),
  },

  mounted() {
    // Check if logged in
    this.refreshUser()
      .then(() => {
        // Yep!
        this.$router.go(-1);
      })
      .catch(() => {
        this.$router.replace({ name: 'Login' });
      });
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/Auth/Init.vue